import {
  createStyles,
  ListItem,
  ListItemText,
  makeStyles,
  Theme,
} from '@material-ui/core'
import React from 'react'
import { PartySearchResult } from '../../../services/APIs/InternalAPI/internal-api.contracts'
import { markText } from '../../../utils/textFilterUtils'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    resultRoot: {
      '& mark': {
        backgroundColor: theme.palette.warning.light,
        color: theme.palette.warning.contrastText,
        padding: theme.spacing(0, 0.5),
      },
    },
  })
)

export function FindPartyResult(props: {
  option: PartySearchResult
  searchText: string
}) {
  const classes = useStyles()

  return (
    <ListItem component="div">
      <ListItemText
        primary={props.option.names.map((name, index) => (
          <div className={classes.resultRoot} key={index}>
            {markText(name, props.searchText)}
          </div>
        ))}
        secondary={
          <span className={classes.resultRoot}>
            {markText(
              props.option.addresses[props.option.addresses.length - 1],
              props.searchText
            )}
          </span>
        }
      />
    </ListItem>
  )
}
